exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n/* style the userImage to fit in nav */\n.toolbar-title-img[data-v-81440b78] {\n  max-width: 35px;\n}\n.beta-text[data-v-81440b78] {\n  /* font-size: .75em; */\n  color: lightcoral;\n}\n.logo[data-v-81440b78]{\n  font-weight: bold;\n  font-size: 30px;\n}\n.main-nav[data-v-81440b78]{\n  z-index: 10;\n  position: fixed;\n  width: 100%;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-81440b78","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Navigation.vue
// module id = r3lP
// module chunks = 1